import { CustomPostFieldTypes } from 'common/api/resources/postFields';
import validateInput from 'common/validateInput';

export const CustomFieldTypes = {
  [CustomPostFieldTypes.integer]: {
    hasOptions: false,
    label: 'Number',
    name: CustomPostFieldTypes.integer,
    optionsLimit: 0,
    validator: validateInput.primitives.integer,
    postTransform: String,
  },
  [CustomPostFieldTypes.multilineText]: {
    hasOptions: false,
    label: 'Multiline text',
    name: CustomPostFieldTypes.multilineText,
    optionsLimit: 0,
    validator: validateInput.string,
    postTransform: null,
  },
  [CustomPostFieldTypes.multiselect]: {
    hasOptions: true,
    label: 'Multiselect Dropdown',
    name: CustomPostFieldTypes.multiselect,
    optionsLimit: 25,
    // For form editing, validate that the input is a string
    // The backend endpoint handles validation that the submitted option exists for this custom field
    // Avoid using validateInput.customPostField.option here - it rejects long options even when they're valid
    validator: validateInput.arrayOf(validateInput.customPostField.option),
    postTransform: null,
  },
  [CustomPostFieldTypes.dropdown]: {
    hasOptions: true,
    label: 'Dropdown',
    name: CustomPostFieldTypes.dropdown,
    optionsLimit: 25,
    // For form editing, validate that the input is a string
    // The backend endpoint handles validation that the submitted option exists for this custom field
    // Avoid using validateInput.customPostField.option here - it rejects long options even when they're valid
    validator: validateInput.string,
    postTransform: null,
  },
  [CustomPostFieldTypes.text]: {
    hasOptions: false,
    label: 'Single-line text',
    name: CustomPostFieldTypes.text,
    optionsLimit: 0,
    validator: validateInput.string,
    postTransform: null,
  },
} as const;

export const CustomFieldTypesList = Object.values(CustomFieldTypes).map((type) => type.name);

export const Errors = {
  extraFields: 'too many fields',
  incompatibleTypes: 'invalid field types',
  missingFields: 'missing required fields',
};

export enum CustomFieldFilterOperators {
  contains = 'contains',
  doesNotEqual = 'doesNotEqual',
  equals = 'equals',
  equalsBool = 'equalsBool',
  equalsOneOf = 'equalsOneOf',
  greaterThan = 'greaterThan',
  isEmpty = 'isEmpty',
  isNotEmpty = 'isNotEmpty',
  lessThan = 'lessThan',
  notContains = 'notContains',
}
